
// @ts-nocheck


export const localeCodes =  [
  "en",
  "es",
  "es-mx",
  "pt",
  "pt-br",
  "de",
  "fr",
  "it",
  "keys-test"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en.json", load: () => import("../locales/en.json" /* webpackChunkName: "locale__vercel_path0_locales_en_json" */), cache: true },
{ key: "../locales/en_loc.json", load: () => import("../locales/en_loc.json" /* webpackChunkName: "locale__vercel_path0_locales_en_loc_json" */), cache: true }],
  "es": [{ key: "../locales/es.json", load: () => import("../locales/es.json" /* webpackChunkName: "locale__vercel_path0_locales_es_json" */), cache: true }],
  "es-mx": [{ key: "../locales/es_MX.json", load: () => import("../locales/es_MX.json" /* webpackChunkName: "locale__vercel_path0_locales_es_MX_json" */), cache: true }],
  "pt": [{ key: "../locales/pt.json", load: () => import("../locales/pt.json" /* webpackChunkName: "locale__vercel_path0_locales_pt_json" */), cache: true }],
  "pt-br": [{ key: "../locales/pt_BR.json", load: () => import("../locales/pt_BR.json" /* webpackChunkName: "locale__vercel_path0_locales_pt_BR_json" */), cache: true }],
  "de": [{ key: "../locales/de.json", load: () => import("../locales/de.json" /* webpackChunkName: "locale__vercel_path0_locales_de_json" */), cache: true }],
  "fr": [{ key: "../locales/fr.json", load: () => import("../locales/fr.json" /* webpackChunkName: "locale__vercel_path0_locales_fr_json" */), cache: true }],
  "it": [{ key: "../locales/it.json", load: () => import("../locales/it.json" /* webpackChunkName: "locale__vercel_path0_locales_it_json" */), cache: true }],
  "keys-test": []
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "files": [
        "/vercel/path0/locales/en.json",
        "/vercel/path0/locales/en_loc.json"
      ]
    },
    {
      "code": "es",
      "files": [
        "/vercel/path0/locales/es.json"
      ],
      "domainDefault": true
    },
    {
      "code": "es-mx",
      "files": [
        "/vercel/path0/locales/es_MX.json"
      ]
    },
    {
      "code": "pt",
      "files": [
        "/vercel/path0/locales/pt.json"
      ],
      "domainDefault": true
    },
    {
      "code": "pt-br",
      "files": [
        "/vercel/path0/locales/pt_BR.json"
      ]
    },
    {
      "code": "de",
      "files": [
        "/vercel/path0/locales/de.json"
      ]
    },
    {
      "code": "fr",
      "files": [
        "/vercel/path0/locales/fr.json"
      ]
    },
    {
      "code": "it",
      "files": [
        "/vercel/path0/locales/it.json"
      ]
    },
    {
      "code": "keys-test"
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": true,
  "langDir": "locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "fallbackLocale": "en",
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "files": [
      {
        "path": "/vercel/path0/locales/en.json"
      },
      {
        "path": "/vercel/path0/locales/en_loc.json"
      }
    ]
  },
  {
    "code": "es",
    "files": [
      {
        "path": "/vercel/path0/locales/es.json"
      }
    ],
    "domainDefault": true
  },
  {
    "code": "es-mx",
    "files": [
      {
        "path": "/vercel/path0/locales/es_MX.json"
      }
    ]
  },
  {
    "code": "pt",
    "files": [
      {
        "path": "/vercel/path0/locales/pt.json"
      }
    ],
    "domainDefault": true
  },
  {
    "code": "pt-br",
    "files": [
      {
        "path": "/vercel/path0/locales/pt_BR.json"
      }
    ]
  },
  {
    "code": "de",
    "files": [
      {
        "path": "/vercel/path0/locales/de.json"
      }
    ]
  },
  {
    "code": "fr",
    "files": [
      {
        "path": "/vercel/path0/locales/fr.json"
      }
    ]
  },
  {
    "code": "it",
    "files": [
      {
        "path": "/vercel/path0/locales/it.json"
      }
    ]
  },
  {
    "code": "keys-test",
    "files": []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
